export default function filterSameValues(values, fieldName) {
    return values.reduce((a, o) => {
        const v = o[fieldName];
        if (typeof v === "undefined" || v === null || v === "") {
            return a;
        }
        return a.includes(v) ? a : a.concat(v);
    }, []);
}
